// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"86037e63","113":"25044907","181":"0651e8d4","481":"de2161b3","488":"eaac93fd","502":"937787d2","523":"c12b37ef","597":"6ac0c972","680":"86541fd7","721":"724e19e0"}[chunkId] + ".chunk.js";
};